import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const forecastingHorizonDaysValues = [14, 30, 60, 90, 120] as const;
export type ForecastingHorizonDays =
  (typeof forecastingHorizonDaysValues)[number];

const horizonDaysSchema = z.union([
  z.literal(14),
  z.literal(30),
  z.literal(60),
  z.literal(90),
  z.literal(120),
]);

export const getForecastingAccuracyTimeline = {
  name: "getForecastingAccuracyTimeline" as const,
  input: z.object({
    /** Null loads only the merchant list */
    teamId: z.string().nullable(),
    horizonDays: horizonDaysSchema,
  }),
  output: z.object({
    /** IMS merchants with forecast runs, for the merchant selector */
    merchants: z.array(
      z.object({ teamId: z.string(), name: z.string().nullable() }),
    ),
    /**
     * WMAPE per forecast origin date for the requested merchant and horizon,
     * oldest first. Origins whose horizon window hasn't fully elapsed (or with
     * zero actuals) are omitted.
     */
    series: z.array(
      z.object({ originDate: zExt.plainDate(), wmape: z.number() }),
    ),
  }),
};
